import API from './config';
import DIRECTORIO_ENDPOINT from './endpoint';

//catch error
const catchError = (error) => {
    if (error.response) {
        /* 
        * Se hizo la solicitud y el servidor respondió con un
        * código de estado que cae fuera del rango de 2xx
        */
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        return error.response.data
    } else if (error.request) {
        /*
        * se realizó la solicitud pero no se recibió respuesta, `error.request`
        * es una instancia de XMLHttpRequest en el navegador y una instancia
        * de http.ClientRequest en Node.js 
        * */
        console.log(error.request);
        return error.request;
    } else {
        // Algo sucedió al configurar la solicitud y provocó un error
        console.log('Error', error.message);
        return error.message
    }
}

// FILTRAR TIPOS EN TABLA DE EMPLEADO              OBJETO
export const getColumnaFiltrarEmpleados = async (parametro) => {

    try {

        const response = API({
            method: 'GET',
            url: DIRECTORIO_ENDPOINT.FILTRARTIPOS,
            params: parametro
        });

        const { data } = await response;
        return data;

    } catch (error) {
        const data = catchError(error);
        return data;
    }
}

// BUSCAR EMPLEADO
// FILTRAR TIPOS EN TABLA DE EMPLEADO              OBJETO
export const getBuscarEmpleado = async (parametros) => {

    try {

        const response = API({
            method: 'GET',
            url: DIRECTORIO_ENDPOINT.BUSCAREMPLEADO,
            params: parametros
        });

        const { data } = await response;
        return data;

    } catch (error) {
        const data = catchError(error);
        return data;
    }
}

// DATOS DE EMPLEADO
export const getDatosEmpleados = async () => {

    try {
        const response = API({
            method: 'GET',
            url: DIRECTORIO_ENDPOINT.DATOSEMPLEADOS
        });

        const { data } = await response;
        return data;

    } catch (error) {
        const data = catchError(error);
        return data;
    }
}